// import { from } from '@apollo/client'
// import { cn } from '@fullcalendar/core/internal-common'
import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { memo, useState } from 'react'
import { FilterOption, TaxonomyType } from 'src/types'

import SkeletonLoading from '../SkeletonLoading/SkeletonLoading'

// import { Accordion } from '../SidebarItem/Accordion'
// import { DateRangePicker } from '../SidebarItem/DateRangePicker'
// import { SidebarTopicFilter } from '../SidebarTopicFilter/SidebarTopicFilter'
// import { TopicList } from '../TopicList/TopicList'

export interface SidebarMenuItem {
  title: string
  subtitles: string[]
}

export interface SidebarProps {
  className?: string
  filterOptions: FilterOption[]
  filtersDisabled?: boolean
  defaultSelectFilterIdx?: number
  onClickWhenDisabled?: () => void
  filterHeight?: boolean | null
}

const SidebarTopicFilter = dynamic(
  () => import('../SidebarTopicFilter/SidebarTopicFilter').then((mod) => mod.SidebarTopicFilter),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const TopicList = dynamic(() => import('../TopicList/TopicList').then((mod) => mod.TopicList), {
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const DateRangePicker = dynamic(() => import('../SidebarItem/DateRangePicker').then((mod) => mod.DateRangePicker), {
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const Accordion = dynamic(() => import('../SidebarItem/Accordion').then((mod) => mod.Accordion), {
  loading: () => <SkeletonLoading className="bg-navy" />,
})

export const Sidebar: React.FC<SidebarProps> = memo(
  ({
    className = '',
    filtersDisabled = false,
    defaultSelectFilterIdx = 0,
    filterOptions,
    onClickWhenDisabled,
    filterHeight = false,
  }) => {
    const [selectedAccordion, setSelectedAccordion] = useState<TaxonomyType | null>(
      filterOptions[defaultSelectFilterIdx].title,
    )

    const onSelectAccordion = (title: TaxonomyType) => {
      if (title === selectedAccordion) {
        setSelectedAccordion(null)
      } else {
        setSelectedAccordion(title)
      }
    }

    return (
      <div className={cn(className, 'mobile_filter_scroll')}>
        <div className={`md:max-w-[15rem] md:w-[240px] w-full ${filterHeight ? 'hide-filter-free-popup' : ''}`}>
          {filterOptions.map((filter: FilterOption, index: number) => {
            const opened = selectedAccordion === filter.title
            if (filter.title !== TaxonomyType.Date && (!filter.data || !filter.data.length)) return
            if (filter.title === TaxonomyType.Subtopic && filter.slug) {
              return (
                <div key={index}>
                  <hr></hr>
                  <SidebarTopicFilter
                    title={TaxonomyType.Subtopic}
                    topicSlug={filter.slug}
                    items={filter.data}
                    opened={opened}
                    disabled={filtersDisabled}
                    onSelectAccordion={onSelectAccordion}
                    onClickWhenDisabled={onClickWhenDisabled}
                  />
                </div>
              )
              // } else if (filter.title === TaxonomyType.ProductType || filter.title === TaxonomyType.Topic) {
            } else if (filter.title === TaxonomyType.ProductType) {
              return (
                <div key={index}>
                  <hr></hr>
                  <TopicList
                    title={TaxonomyType.ProductType}
                    items={filter.data}
                    opened={opened}
                    disabled={filtersDisabled}
                    showCheckbox
                    onSelectAccordion={onSelectAccordion}
                    onClickWhenDisabled={onClickWhenDisabled}
                  />
                </div>
              )
            } else if (filter.title === TaxonomyType.Topic) {
              return (
                <div key={index}>
                  <hr></hr>
                  <TopicList
                    title={TaxonomyType.Topic}
                    items={filter.data}
                    opened={opened}
                    disabled={filtersDisabled}
                    showCheckbox
                    onSelectAccordion={onSelectAccordion}
                    onClickWhenDisabled={onClickWhenDisabled}
                  />
                </div>
              )
            } else if (filter.title === TaxonomyType.Date) {
              return (
                <div key={index}>
                  <hr></hr>
                  <DateRangePicker
                    title={TaxonomyType.Date}
                    items={filter.data}
                    opened={opened}
                    disabled={filtersDisabled}
                    showCheckbox
                    onSelectAccordion={onSelectAccordion}
                    onClickWhenDisabled={onClickWhenDisabled}
                  />
                </div>
              )
            } else {
              return (
                <div key={index}>
                  <hr></hr>
                  <Accordion
                    title={filter.title}
                    items={filter.data}
                    opened={opened}
                    disabled={filtersDisabled}
                    showCheckbox
                    onSelectAccordion={onSelectAccordion}
                    onClickWhenDisabled={onClickWhenDisabled}
                  />
                </div>
              )
            }
          })}
        </div>
      </div>
    )
  },
)
